export default __webpack_public_path__ + "84e9629f2b12511bc833b1f3ad12796c.svg";